// extracted by mini-css-extract-plugin
module.exports = {"title":"_93444fe79c--title--D5tNa","logo":"_93444fe79c--logo--pL7Or","control":"_93444fe79c--control--Junce"};